export default {
  hero: {
    badge: 'AllChinaBuy Spreadsheet Ressourcen-Hub',
    title: 'AllChinaBuy Spreadsheet – Produkte finden, vergleichen & cleverer kaufen',
    subtitle: 'Entdecke das AllChinaBuy Spreadsheet an einem organisierten Ort. Finde Produktempfehlungen, beliebte Kategorien, QC-Ratgeber, Versandinfos, Bewertungen und praktische Kaufressourcen.',
    ctaPrimary: 'AllChinaBuy Spreadsheet entdecken',
    ctaSecondary: 'Beliebte Funde ansehen',
    mainCta1: 'allchinabuy spreadsheet',
    mainCta2: 'jetzt kaufen',
  },
  search: {
    label: 'Im AllChinaBuy Spreadsheet suchen',
    placeholder: 'Kategorien, Ratgeber, Bewertungen suchen...',
    categoryLabel: 'Nach Kategorie stöbern',
    selectPlaceholder: 'Kategorie wählen',
    go: 'Zur Kategorie',
  },
  categories: {
    title: 'Beliebte Kategorien',
    subtitle: 'Spring direkt zu den Produkten, die dich interessieren. Jede Kategorie öffnet sich im Haupt-AllChinaBuy-Spreadsheet.',
  },
  guides: {
    title: 'Ratgeber & Ressourcen',
    subtitle: 'Praktische Anleitungen zu Qualitätskontrolle, Versand, Bewertungen und sicherem Kauf.',
  },
  featured: {
    title: 'Ausgewählte Funde',
    subtitle: 'Ein Blick auf die Produkte, die Nutzer am häufigsten in ihren Tabellen speichern.',
    items: [
      { title: 'Robuste Alltags-Sneaker', body: 'Klare Silhouetten und solide Materialien machen sie zu einem Dauerfavoriten auf vielen Kauflisten.' },
      { title: 'Boxy Streetwear-Hoodies', body: 'Schwerer Baumwollstoff und Oversize-Passform dominieren die Hoodie-Sektion der Tabelle.' },
      { title: 'Minimalistische Logo-Tees', body: 'Schlichte, vielseitige Shirts, die sich gut kombinieren lassen und im Budget bleiben.' },
      { title: 'Utility-Jacken & Oberbekleidung', body: 'Technische Stoffe und lässige Schnitte, die über alle Jahreszeiten funktionieren.' },
    ],
  },
  qc: {
    title: 'QC-Ratgeber',
    subtitle: 'So liest du Qualitätskontroll-Fotos vor dem Versand.',
    body: 'Bevor deine Artikel das Lager verlassen, prüfe die QC-Fotos genau. Achte auf Nähte, Farbtreue, Logo-Position und Maße im Vergleich zur Größentabelle.',
  },
  shipping: {
    title: 'Versand-Ratgeber',
    subtitle: 'Verstehe deine Versandoptionen und Kosten.',
    body: 'Vergleiche Versandlinien nach Geschwindigkeit, Preis und Zuverlässigkeit. Schwerere oder sperrige Artikel kosten meist mehr, daher spart das Bündeln eines kompletten Hauls oft Geld.',
  },
  review: {
    title: 'AllChinaBuy Bewertung',
    subtitle: 'Ein ehrlicher Blick auf die Funktionsweise.',
    body: 'Von der Bestellung bis zur Paketverfolgung – erfahre, was dich erwartet, wo der Service glänzt und worauf du achten solltest.',
  },
  safety: {
    title: 'Sicherheitszentrum',
    subtitle: 'Kaufe mit gutem Gefühl.',
    body: 'Tipps zu Kontosicherheit, sicherem Bezahlen, Vermeidung von Fälschungen sowie zum Verständnis von Zoll und eingeschränkten Produkten.',
  },
  articles: {
    title: 'Neueste Artikel',
    subtitle: 'Ausführliche Ratgeber und ehrliche Berichte, damit du cleverer kaufst.',
    readMore: 'Artikel lesen',
    viewAll: 'Alle Artikel ansehen',
  },
  faq: {
    title: 'Häufig gestellte Fragen',
    subtitle: 'Schnelle Antworten auf die häufigsten Fragen.',
    items: [
      { q: 'Was ist das AllChinaBuy Spreadsheet?', a: 'Es ist eine organisierte Sammlung von Produktempfehlungen, Kategorien und Kaufressourcen, die dir hilft, Artikel vor dem Kauf zu entdecken und zu vergleichen.' },
      { q: 'Ist AllChinaBuy seriös?', a: 'Überprüfe die aktuellen Richtlinien immer selbst. Unsere Ratgeber helfen dir, den Ablauf zu verstehen, aber du solltest Bedingungen, Verkäuferbewertungen und lokale Vorschriften vor der Bestellung prüfen.' },
      { q: 'Wie viel kostet der Versand?', a: 'Die Versandkosten hängen von Gewicht, Größe, Zielort und der gewählten Versandlinie ab. Das Bündeln mehrerer Artikel in ein Paket senkt oft den Gesamtpreis.' },
      { q: 'Wie lese ich QC-Fotos?', a: 'Prüfe Nähte, Farben, Logos und Maße anhand des Angebots und der Größentabelle. Melde jede Abweichung, bevor deine Artikel versandt werden.' },
    ],
  },
  cta: {
    title: 'Bereit, die ganze Tabelle zu entdecken?',
    subtitle: 'Besuche die Hauptseite, um jede Kategorie zu durchstöbern und deinen nächsten Lieblingsfund zu machen.',
    button: 'Hauptseite besuchen',
  },
};